// assets/product-video.js
const videoInitialized = window.productVideoInitialized || false;

document.addEventListener('DOMContentLoaded', function() {
  console.log('Video script starting');
  
  if (videoInitialized) return; 
  window.productVideoInitialized = true;
  // Log all potential gallery elements
  const allGalleries = document.querySelectorAll('.gallery, .variant-images-gallery');
  console.log('Found galleries:', allGalleries.length);
  allGalleries.forEach((el, i) => console.log(`Gallery ${i}:`, el));
  
  // Try to find a specific gallery
  const gallery = document.querySelector('.gallery, .variant-images-gallery');
  console.log('Selected gallery:', gallery);
  
  // Log the parent elements where we might want to insert
  const leftColumn = document.querySelector('.left');
  console.log('Left column:', leftColumn);
  
  const productMedia = document.querySelector('.product-media');
  console.log('Product media:', productMedia);
  
  if (gallery) {
    const fragment = document.createDocumentFragment();
    const videoSection = document.createElement('div');
    videoSection.className = 'product-video-section';
    const videoTitle = document.createElement('div');
    videoTitle.className = 'product-video-title';
    videoTitle.textContent = window.productVideoTitle || 'Product Video';
    
    // Log the video info we're working with
    console.log('Video URL:', window.productVideoUrl);
    console.log('Video Title:', window.productVideoTitle);

    const videoDesc = document.createElement('div');
    videoDesc.className = 'video-description';
    videoDesc.innerHTML = window.productVideoDescription || 'Learn more about this product in the video below.';

    const videoWrapper = document.createElement('div');
    videoWrapper.className = 'product-video-wrapper loading';

    const video = document.createElement('iframe');
    video.loading = 'lazy';
    video.title = videoTitle.textContent;
    video.setAttribute('aria-label', videoDesc.textContent);
    video.setAttribute('tabindex', '0');
    video.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    video.referrerPolicy = 'strict-origin-when-cross-origin';
    video.allowFullscreen = true;

    let videoUrl = window.productVideoUrl;
    let videoSrc;

    // FIXED: Add safety check for undefined videoUrl
    if (videoUrl && typeof videoUrl === 'string') {
      // Handle YouTube Shorts URL
      if (videoUrl.includes('youtube.com/shorts/')) {
        const videoId = videoUrl.split('youtube.com/shorts/')[1].split('?')[0];
        videoSrc = 'https://www.youtube.com/embed/' + videoId;
      } else if (videoUrl.includes('youtu.be/')) {
        const videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
        videoSrc = 'https://www.youtube.com/embed/' + videoId;
      } else if (videoUrl.includes('youtube.com/watch')) {
        videoSrc = videoUrl.replace('watch?v=', 'embed/');
      } else {
        videoSrc = videoUrl;
      }

      video.dataset.src = videoSrc + '?rel=0&modestbranding=1&enablejsapi=1&origin=' + window.location.origin;

      video.addEventListener('load', function () {
        video.classList.add('loaded');
        videoWrapper.classList.remove('loading');
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'product_video_loaded',
            videoTitle: videoTitle.textContent,
            productId: window.productId,
            productTitle: window.productTitle,
          });
        }
      }, { passive: true });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const iframe = entry.target.querySelector('iframe');
              if (iframe && iframe.dataset.src) {
                iframe.src = iframe.dataset.src;
                observer.unobserve(entry.target);
                if (typeof window.dataLayer !== 'undefined') {
                  window.dataLayer.push({
                    event: 'product_video_visible',
                    videoTitle: videoTitle.textContent,
                    productId: window.productId,
                    visibilityPercent: Math.round(entry.intersectionRatio * 100),
                  });
                }
              }
            }
          });
        },
        {
          rootMargin: '50px 0px',
          threshold: 0.1,
        }
      );

      videoWrapper.appendChild(video);
      videoSection.appendChild(videoTitle);
      videoSection.appendChild(videoDesc);
      videoSection.appendChild(videoWrapper);
      fragment.appendChild(videoSection);

      gallery.after(fragment);
      observer.observe(videoWrapper);
    } else {
      console.log('No video URL provided or invalid URL type');
    }
  } else {
    console.log('No gallery element found'); // Debug log
  }
}, { passive: true });